import enums from "../utils/enums";
import { checkMetadataControlValue, createViewMetaData, createComponentMetaData, validateCaption, createPinyinField, setCtrlMetadataFullCode } from "./designerMetadataHelper";

let postForm = ["form", "question", "exam"];
function getParentControl(el) {
  let target = $(el);
  let slotEl = $(target).closest("[slot-name]");
  let container = null;

  let mark = false;
  //判断插槽元素是否本身就是一个组件且不是一个被镶嵌在其他组件内部
  if (slotEl.hasClass("ds-control")) {
    let vueComponent = slotEl.get(0).__vue__;
    container = vueComponent;
    if (container.$$getComponent) {
      container = container.$$getComponent();
    }
  } else {
    mark = true;
  }
  if (mark) {
    container = slotEl.parents(".ds-control");
    if (container.get(0)) {
      let vueComponent = container.get(0).__vue__;
      container = vueComponent;
    }
  }
  if (container) {
    let layoutContainer = container;
    let layoutParent = layoutContainer.$layoutTree;
    // let ctrlType = layoutContainer.ctrlType;
    while (!layoutParent) {
      layoutContainer = layoutContainer.$parent;
      layoutParent = layoutContainer.$layoutTree;
    }
    if (layoutParent) {
      return layoutParent;
    }
  }
  // //插糟是个普通的html元素
  // else {
  //   mark = true;
  // }
  // if (mark) {
  //   container = slotEl.parents(".ds-control");
  //   if(container.get(0)){
  //     let vueComponent = container.get(0).__vue__;
  //     if(vueComponent){
  //       let layoutParent=vueComponent.$layoutParent;
  //       if(layoutParent){
  //         container=layoutParent.$$getComponent()
  //       }
  //     }
  //   }
  // } else {
  //   container = slotEl;
  // }
  // return container;
}

function getDsfComponent(comp, maxComponent) {
  let vueComponent = comp;
  if (vueComponent) {
    //如果组件不是按我们系统规范创建的组件则继续向上查找
    if (vueComponent.$$getComponent) {
      vueComponent = vueComponent.$$getComponent();
    }
    while (!vueComponent.$props.isDsf || !vueComponent.$props.ctrlName) {
      vueComponent = vueComponent.$parent;
      if (vueComponent.$$getComponent) {
        vueComponent = vueComponent.$$getComponent();
      }
      if (vueComponent.$el == maxComponent.$el) {
        vueComponent = null;
        break;
      }
    }
  }
  return vueComponent;
}

function createComponent(name, attrs, isSilent) {
  let comp = dsf.createComponent(name, attrs);
  if (!comp) {
    isSilent !== true && dsf.layer.message(`【${name}】组件在当前客户端尚未被支持`, false);
    return null;
  }
  if (!comp.designId) {
    comp.designId = dsf.uuid();
  }
  return comp;
}

function createMobileComponent(name, attrs, isSilent) {
  name = getComponentCodeByClient(name, true);
  let comp = dsf.createComponent(name, attrs, isSilent);
  if (!comp) {
    isSilent !== true && dsf.layer.message(`【${name}】组件在当前客户端尚未被支持`, false);
    return null;
  }
  if (!comp.designId) {
    comp.designId = dsf.uuid();
  }
  return comp;
}
//根据不同客户端获取组件代码
function getComponentCodeByClient(code, isMobile) {
  if (isMobile) {
    if (dsf.type(code) == "string") {
      let arr = code.split(".");
      if (arr[1] != "mobile") {
        arr.splice(1, 0, "mobile");
        code = arr.join(".");
      }
    }
  }
  return code;
}

//获取触发事件的组件
function getComponentByTarget(target) {
  target = $(target);
  target = target.closest(".designer-ctrl-proxy");
  let component = target.get(0).__vue__;
  if (component) {
    component = component.$$getComponent ? component.$$getComponent() : component;
    return component;
  }
  return null;
}

function getRealComponent(target) {
  target = target.jquery ? target.get(0) : target;
  if (target.__vue__) {
    let com = target.__vue__;
    if (com.$$getComponent) {
      com = com.$$getComponent();
    }
    return com;
  }
  return null;
}

//是否允许拖放
function isAllowDrop(target, maxComponent) {
  let curr = null,
    count = 0,
    allow = true;
  if (!target) {
    return false;
  }
  if (target.jquery) {
    curr = target.length > 0 ? target.get(0) : null;
  } else {
    curr = target;
  }
  if (!curr) {
    return false;
  }
  //如果标记上存在disabled-drop样式则不允许拖动
  if (curr.matches(".disabled-drop") || curr.matches(".freeze-slot")) {
    return false;
  }
  do {
    if (curr == maxComponent.$el) {
      break;
    }
    if (curr.__vue__) {
      let vueComponent = getDsfComponent(curr.__vue__, maxComponent);
      if (vueComponent && !vueComponent.$props.isDesign) {
        allow = false;
        break;
      } else {
        break;
      }
    } else {
      curr = curr.parentNode;
    }
    count++;
  } while (count < 100);
  return allow;
}

//将组件转化为json
function controlToJson(ctrl, callback) {
  if (callback) {
    JSON.stringify(ctrl, callback);
  }
  return JSON.stringify(ctrl);
}

//向下传播设计器事件
function broadcast(sourceComponent, eventName, evt, params, excludeComponent) {
  sourceComponent.$children.forEach((child) => {
    if (child.$options.design && child.$options.design[eventName]) {
      if (excludeComponent != child) {
        child.$options.design[eventName].call(child, evt, params);
      }
    }
    broadcast(child, eventName, evt, params, excludeComponent);
  });
}

//保存布局是被排除的属性
let layoutExclude = ["layoutRoot", "layoutParent", "isDesign", "$vm", "local"];

function getLayoutInfo(page, isPreView) {
  let arrs = [],
    root = null,
    currentSlots = {},
    temp = [];
  // recursionLayoutTree(page, null, null, (component, parent, slotName) => {
  //   let props = component.$props;
  //   delete props.$layoutParent;
  //   Object.defineProperty(props, "$layoutParent", {
  //     value: parent,
  //     configurable: true,
  //     writable: true,
  //     enumerable: false
  //   });
  //   temp.push(temp);
  // });
  recursionLayoutTree(
    page,
    null,
    null,
    (component, parent, slotName) => {
      let parentProps = arrs[arrs.length - 1];
      let designOptions = component.$options ? component.$options.design : null;
      if (designOptions) {
        let layoutNode = designOptions.layout || {};
        layoutNode.before && layoutNode.before.call(component);
      }
      let slotProps = component.$props.slots;
      if (parent) {
        currentSlots[parent.designId] = slotName;
      }
      // delete component.$props.slots;
      let copyPorps = {};
      for (let k in component.$props) {
        if (k != "slots") {
          copyPorps[k] = component.$props[k];
        }
      }
      let props = dsf.mix(true, {}, copyPorps);
      props.slots = _.map(slotProps, (it) => {
        let s = {};
        for (let k in it) {
          if (k != "controls") {
            s[k] = it[k];
          }
        }
        s.controls = [];
        return s;
      });
      if (component.$attrs["slot-name"]) {
        props["slot-name"] = component.$attrs["slot-name"];
      }
      Object.defineProperty(props, "$slotsMap", {
        value: _.keyBy(props.slots, "name"),
        enumerable: false,
        configurable: true
      });
      let excludeProps = [...layoutExclude];
      if (component.$options && component.$options.design) {
        let layout = component.$options.design.layout;
        if (layout) {
          let exclude = layout.exclude || [];
          excludeProps = excludeProps.concat(exclude);
        }
      }
      //该处原是为处理一件事表单处理，现在取消该判断
      // if (component.isFormControl) {
      //   if (component?.$parent?.$parent && component?.$parent?.$parent?.span) {
      //     //查找组件父亲，如果在dsfcol组件内则记录下组件占多少栅格，改属性可用于自动布局
      //     props.colSpan = component.$parent.$parent.span || 24;
      //   } else {
      //     props.colSpan = 24;
      //   }
      // }
      _.each(excludeProps, (exc) => {
        if (isPreView) {
          if (!exc.startsWith("#")) {
            delete props[exc];
          }
        } else {
          if (exc.startsWith("#")) {
            delete props[exc.substr(1)];
          } else {
            delete props[exc];
          }
        }
      });
      // let index = arrs.length - 1;
      // let formErrorLocationSlot = null;
      // let formErrorLocationComponent = null;
      // // eslint-disable-next-line no-cond-assign
      // while (arrs[index]) {
      //   let c = arrs[index];
      //   if (c.formErrorLocationSlot) {
      //     formErrorLocationSlot = currentSlots[c.designId];
      //     formErrorLocationComponent = c.designId;
      //     break;
      //   }
      //   index--;
      // }
      // if (formErrorLocationSlot && formErrorLocationComponent) {
      //   props.locationSlotComponent = formErrorLocationComponent;
      //   props.locationSlotName = formErrorLocationSlot;
      // }
      arrs.push(props);

      if (!parentProps) {
        root = props;
      }
      let slots = props.slots;
      _.each(slots, (slot) => {
        slot.controls = [];
      });
      if (parentProps) {
        let slot = parentProps.$slotsMap[slotName];
        // let slot = _.find(parentProps.slots, s => s.name == slotName);
        if (slot) {
          slot.controls.push(props);
        }
      }
    },
    () => {
      arrs.pop();
    }
  );
  // _.each(temp || [], (it) => {
  //   delete it.$layoutParent;
  // });
  return root;
}

//获取页面配置的所有静态数据
function getStaticValue(page) {
  // console.time("搜集页面使用的静态数据");
  let staticValue = {};
  recursionLayoutTree(page, null, null, (component, parent, slotName) => {
    if (component.staticValue && component.caption) {
      staticValue[component.caption] = component.staticValue;
    }
  });
  // console.timeEnd("搜集页面使用的静态数据");
  return staticValue;
}

function getDoc(designer) {
  return designer.pageDocument;
}
//解析页面
function analysisLayoutInfo(res) {
  let layout = null,
    scss = null,
    staticValue = null,
    doc = null,
    designer = null;
  let dom = $("<div>" + res.data + "</div>");
  let layoutStr = dom.children("script[id='layout']").html() || "";
  let scssStr = dom.children("script[id='scss']").html() || "";
  let designerStr = dom.children("script[id='designer']").html() || "";
  let staticValueStr = dom.children("script[id='staticValue']").html() || "";
  let docStr = dom.children("script[id='doc']").html() || "";
  // let onlineStr = dom.children("script[id='onLineComponents']").html() || "";
  let layoutFn = new Function(["var layout=" + (layoutStr || "null") + ";", "return layout;"].join("\n"));
  let scssFn = new Function(["return " + JSON.stringify(scssStr.trim() || "")].join("\n"));
  let designerFn = new Function(["return " + (designerStr.trim() || "{}").trim()].join("\n"));
  let staticValueFn = new Function(["return " + (staticValueStr.trim() || "{}").trim()].join("\n"));
  let docFn = new Function(["return " + JSON.stringify(dsf.unescapeHTML(docStr) || "").trim()].join("\n"));
  let layoutObj = layoutFn();
  var returnValue = {
    layout: layoutObj,
    staticValue: staticValueFn(),
    scss: scssFn(),
    designer: designerFn(),
    doc: docFn()
  };

  return new Promise((resolve, reject) => {
    requestAsyncComponentsByLayout(layoutObj).then(() => {
      resolve(returnValue);
    });
  });
}
//解析layout布局
function requestAsyncComponentsByLayout(layout, callback) {
  let asyncComList = [];
  dsf.recursionComponentProps(layout, (prop) => {
    let asyncCom = dsf.checkAsyncComponent(prop.ctrlName);
    let mark = true;
    if (asyncCom && callback) {
      //如果callback返回false则不加载该异步组件
      let _cbres = callback(prop);
      mark = _cbres === false ? false : true;
    }
    if (mark !== false && asyncCom && !asyncComList.includes(asyncCom)) {
      asyncComList.push(asyncCom);
    }
  });
  if (asyncComList.length) {
    return dsf.requestAsyncComponents(asyncComList).then(() => {
      return Promise.resolve();
    });
  } else {
    return Promise.resolve();
  }
}

//递归组件
function recursionLayoutTree(component, parent, slotName, callback, callbackAfter) {
  if (component) {
    while (!component.$$getComponent) {
      component = component.$parent;
    }
    if (!component) {
      return;
    }
    component = component.$$getComponent();
    let isContinue;
    if (callback) {
      isContinue = callback(component, parent, slotName);
    }
    if (isContinue !== false) {
      let designMethods = component.$options.design;
      let layoutNode = designMethods.layout;
      let isdeep = dsf.isFunction(layoutNode.isDeep) ? layoutNode.isDeep.call(component) : layoutNode.isDeep;
      if (isdeep !== false) {
        for (let i = 0; i < component.slots.length; i++) {
          let slot = component.slots[i];
          for (let n = 0; n < slot.controls.length; n++) {
            let control = slot.controls[n];
            let target = control.__layoutTree__;
            if (!target) {
              let desid = control.designId;
              target = component.$designer.allComponents[desid];
              if (!target) {
                target = $("[des-id='" + desid + "']");
                target = target?.get?.(0)?.__vue__ || null;
              }
            }
            recursionLayoutTree(target, component, slot.name, callback, callbackAfter);
            //使用函数式组件代理真实组件的情况，统计云报表设计器使用该方式
            // if (control.__virtual__) {
            //   recursionLayoutTree(control.__layoutTree__, component, slot.name, callback, callbackAfter);
            // } else {
            //   let target = component.$designer.allComponents[desid];
            //   if (!target) {
            //     target = $("[des-id='" + desid + "']");
            //     target = target?.get?.(0)?.__vue__ || null;
            //   }
            //   if (target) {
            //     recursionLayoutTree(target, component, slot.name, callback, callbackAfter);
            //   }
            // }
          }
        }
      }
    }
    callbackAfter && callbackAfter(component, parent, slotName);
  }
}

//保存布局时验证
function saveLayoutValidate(page) {
  let errors = [];
  // console.time("保存前校验");
  recursionLayoutTree(page, null, null, (el, parent, slotName) => {
    if (el.isFormControl) {
      let layout = el.$options.design ? el.$options.design.layout : {};
      let nameValidate = true;
      if (dsf.hasOwn(layout, "nameValidate") && layout.nameValidate === false) {
        nameValidate = false;
      }
      if (isPrototypePage(page)) {
        nameValidate = false;
      }
      if (nameValidate) {
        //验证表单组件的标识不能等于自己组件的名字开头，避免提交时数据库生成无意义的字段和表
        _.each(validateCaption(el), (error) => {
          errors.push(error);
        });
      }
      // 编号控件必须设置编号规则
      if ((el.ctrlType == "dsf.numeration" || el.ctrlType == "dsf.mobile.numeration") && !el.rule) {
        errors.push("请为" + el.caption + "设置编号规则");
      }
    }
  });
  // console.timeEnd("保存前校验");
  if (errors.length) {
    dsf.layer.pc.message(errors[0], false);
    return false;
  }
}

//获取extjs路径
function getExtPath(b, m, pn, isMobile, isTpl) {
  let tplOrViews = isTpl ? "tpl" : "views";
  let folder = [b, m].join(".");
  let clientDirs = isMobile ? "mobile/" + tplOrViews : "pc/" + tplOrViews;
  let extPath = `${clientDirs}/${folder}/${pn}.ext.js`;
  return extPath;
}

function getPageDocumet(b, m, pn, isMobile) {
  let folder = [b, m].join(".");
  let clientDirs = isMobile ? "mobile/views" : "pc/views";
  let docPath = `${clientDirs}/${folder}/${pn}.doc.html`;
  return docPath;
}

//获取layout文件路径
function getLayoutPath(b, m, pn, isMobile, isTpl) {
  let tplOrViews = isTpl ? "temp" : "views";
  let folder = [b, m].join(".");
  // let clientDirs = isMobile ? dsf.url.getWebPath("/mobile/" + tplOrViews) : dsf.url.getWebPath("/pc/" + tplOrViews);
  let clientDirs = isMobile ? "mobile/" + tplOrViews : "pc/" + tplOrViews;
  let htmlPath = `${clientDirs}/${folder}/${pn}.layout.html`;
  return htmlPath;
}

// let innerControls = ['DsfCol', 'DsfTableRow', 'DsfTableCell'];

//转化vue模板
function convertTemplateAndControlData(layout, hasComment, isPreView, options) {
  layout = dsf.mix(true, {}, layout);
  let defaultOptions = {
    before: null,
    after: null
  };
  dsf.mix(defaultOptions, options);
  let parentNodes = [];
  /**
   * node：当前布局组建的props
   * parent：夫组件的props
   * slot：当前组件所在的插槽信息
   * isRepeat：是否在一个表格循环内
   * prefix：循环表格组件的caption前缀（暂时无用）
   * textProxy：遇到表单组件时是否显示一个<span>代理组件的输出（数据列表中使用，避免列表加载数据时每行都要实例化组件）
   */
  function createElement(node, parent, slot, slotScope, scopeDataKey, isRepeat, prefix, textProxy) {
    let arr = [],
      props = {},
      controlHash = "";
    defaultOptions.before && defaultOptions.before(node, parentNodes, slot, slotScope, scopeDataKey);
    if (node) {
      parentNodes.push(node);
    }
    let isFormControl = node.isFormControl;
    let metadataFullCode = node.metadata_fullcode;
    let modelExpress = "$viewData";
    let s = [];
    if (slotScope) {
      s.push(slotScope);
    }
    if (scopeDataKey) {
      s.push(scopeDataKey);
    }
    if (s.length) {
      modelExpress = s.join(".");
    }
    // let modelExpress = (isRepeat) ? (slotScope ? slotScope + (scopeDataKey ? "." + scopeDataKey : "") : "") : "$viewData"
    let attachAttrs = {};
    if (isFormControl && metadataFullCode) {
      attachAttrs["v-model"] = modelExpress + "['" + metadataFullCode + "']";
      //如果是枚举型组件增加items属性的绑定
      if ((node.metadata.ckey == "items-meta-data" || node.metadata.dataSourceWatch) && !isPreView) {
        attachAttrs[":items"] = "$enum['" + metadataFullCode + "']";
      }
    }
    if (node.treeProxy) {
      _.each(node.slots, (s, i) => {
        if (s.controls.length > 0) {
          _.each(s.controls, (c, ii) => {
            let child = createElement(c, parent, { slotName: s.name, slotIndex: i, $index: ii }, slotScope, scopeDataKey, isRepeat, prefix, textProxy);
            arr.push(...child.tpl);
            dsf.mix(props, child.props);
          });
        }
      });
    }
    //特殊判断HTML组件，将html组建内容直接显示到模板
    else if ((node.ctrlName == "DsfHtml" || node.ctrlName == "DsfMobileHtml") && !isPreView) {
      hasComment && arr.push("<!--html组件生成内容-->");
      if (node.html) {
        arr.push(dsf.unescapeHTML(node.html));
      }
    } else {
      let ref = "";
      if (!isRepeat) {
        attachAttrs["v-bind.sync"] = "$controls['" + node.designId + "']";
        if (node.caption) {
          ref = "'" + node.caption + "'";
        }
      } else {
        controlHash = `${modelExpress}.${"$hash"}`;
        attachAttrs["v-bind.sync"] = `$controls['${node.designId}-'+${controlHash}]`;
      }
      attachAttrs[":local"] = modelExpress;
      attachAttrs[":design-id"] = "'" + node.designId + "'";
      attachAttrs[":key"] = "'" + node.designId + "'";
      if (node.isOnce) {
        attachAttrs["v-once"] = "";
      }
      if (ref) {
        attachAttrs[":ref"] = ref;
        attachAttrs[":ctrl-id"] = ref;
      }
      if (node.isView) {
        if (node.loadPrecedence == "data") {
          attachAttrs["v-if"] = "$isLoaded";
        }
        if (node.ctrlType.startsWith("dsf.mobile.")) {
          attachAttrs["v-mobile-loading"] = "loading";
        } else {
          attachAttrs["v-loading.fullscreen"] = "loading";
        }
      }
      let attrMap = getVuePropsAndEventMap(attachAttrs);
      let customAttrs = !isPreView ? getVuePropsAndEventMap(node.development["attrs"] || {}) : {};
      let mergeAttrs = { ...attrMap, ...customAttrs };
      let _textProxy = node.textProxy;
      if (_textProxy) {
        hasComment && arr.push("<!--" + (node.label || node.caption) + "-->");
        // arr.push(`<template>`);
        // let exp = `${modelExpress+ "['" + metadataFullCode + "']"}`;
        let ctrl = "$controls['" + node.designId + "']";
        let attrsArr = _.map(mergeAttrs, (attr) => {
          let name = attr.prefix + attr.propName + attr.modifier;
          if ((attr.prefix == "v-bind" && attr.propName == "") || (attr.prefix == "" && attr.propName == "v-bind")) {
            return `${"v-bind"}="${ctrl}"`;
          } else if (attr.propName == "ref") {
            return "";
          } else if (dsf.isUnDef(attr.value)) {
            return name;
          } else {
            return `${name}=${attr.value}`;
          }
        });
        arr.push(`<DsfTextProxy ${attrsArr.join(" ")}></DsfTextProxy>`);
        props[node.designId] = node;
      } else {
        let attrsArr = _.map(mergeAttrs, (attr) => {
          let name = attr.prefix + attr.propName + attr.modifier;
          if (attr.value) {
            return name + "=" + attr.value;
          } else {
            return name;
          }
        });
        hasComment && arr.push("<!--" + (node.label || node.caption) + "-->");
        let tagName = node.ctrlName;
        let isUseRepeatProxy = false;
        if (isRepeat) {
          let mark = mergeAttrs?.["v-bind"]?.value || "";
          if (mark.startsWith('"$controls[')) {
            isUseRepeatProxy = true;
            let vIfExpress = mergeAttrs?.["v-if"] ? `v-if=${mergeAttrs["v-if"].value}` : "";
            arr.push(`<DsfRepeatProxy ${vIfExpress} :design-id="'${node.designId}'" :hash="${modelExpress}.${"$hash"}">`);
          }
        }
        let defer = node.defer;
        let allowDefer = false;
        if (defer && defer !== "inited") {
          allowDefer = true;
        }
        if (allowDefer && node.isView && node.designProxy) {
          allowDefer = false;
        }
        if (allowDefer) {
          arr.push(`<template v-if="defer('${node.defer}')">`);
        }
        tagName && arr.push("<" + tagName + " " + attrsArr.join(" ") + ">");
        // arr.push("<" + node.ctrlName + " " + attrsArr.join(" ") + ">");
        if (node.development["slots"] && !isPreView) {
          arr.push(node.development["slots"]);
        }
        _.each(node.slots, (s, i) => {
          if (s.controls.length > 0) {
            let templateMark = true;
            // if (s.name == "default" && !s.scope) {
            //   templateMark = false;
            // }
            if (templateMark) {
              //添加插槽内容
              arr.push("<template #" + s.name + (s.scope ? "=" + JSON.stringify(s.scope) : "") + ">");
            }
            let repeat = s.repeat === true ? true : false;
            if (isRepeat) {
              repeat = true;
            }
            let prefix = s.repeat === true ? node.caption : "";
            let dataKey = s.dataKey || scopeDataKey;
            let scopeName = s.scope || slotScope;
            let textProxy = s.textProxy;
            _.each(s.controls, (c, ii) => {
              let child = createElement(c, node, { slotName: s.name, slotIndex: i, $index: ii }, scopeName, dataKey, repeat, prefix, textProxy);
              arr.push(...child.tpl);
              dsf.mix(props, child.props);
            });
            if (templateMark) {
              arr.push("</template>");
            }
          }
        });
        tagName && arr.push("</" + tagName + ">");
        if (allowDefer) {
          arr.push("</template>");
        }
        if (isUseRepeatProxy) {
          arr.push("</DsfRepeatProxy>");
        }
        props[node.designId] = node;
      }
    }

    defaultOptions.after && defaultOptions.after(node, parentNodes, slot, slotScope, scopeDataKey);
    parentNodes.pop();
    return {
      props: props,
      tpl: arr
    };
  }
  let result = createElement(layout, null);
  return {
    props: result.props,
    tpl: result.tpl.join("\n")
  };
}

let vueProp_rexp = /^:|^\.|^v-bind:/;
let vueEvent_rexp = /^@|^v-on:/;
function getVuePropsAndEventMap(props) {
  let attrMap = {};
  _.each(props, (s, i) => {
    // let attr = attachAttrs[i];
    var propExpressArray = i.split(".");
    let propName = "",
      prefix = "",
      modifier = "",
      value = "";
    let single = ["v-once"];
    let index = single.indexOf(i);
    if (index >= 0) {
      propName = single[index];
      prefix = "";
      modifier = "";
      value = undefined;
    } else {
      // if(i.indexOf(""))
      vueProp_rexp.lastIndex = 0;
      vueEvent_rexp.lastIndex = 0;
      if (vueProp_rexp.test(i)) {
        //属性
        let rexp_prop = /^(:|v-bind:?)?([^\.:)]*)(\..+)?/g;
        let group = rexp_prop.exec(i);
        if (group && group.length > 1) {
          propName = group[2];
          prefix = group[1];
          modifier = group[3];
        }
      } else if (vueEvent_rexp.test(i)) {
        //事件
        let rexp_event = /^(@|v-on:?)?([^\.)]*)(\..+)?/g;
        let group = rexp_event.exec(i);
        if (group && group.length > 1) {
          propName = group[2];
          prefix = group[1];
          modifier = group[3];
        }
      } else {
        //其他类型（指令，过滤器等其他属性）
        let rexp_other = /([^\.]+)(\.[^\.]+)?/g;
        let group = rexp_other.exec(i);
        if (group && group.length > 1) {
          propName = group?.[1] || "";
          prefix = "";
          modifier = group?.[2] || "";
        }
      }

      if (dsf.type(s) != "string" && (propExpressArray[0].startsWith(":") || propExpressArray[0].startsWith("v-bind:"))) {
        s = "" + s;
      }
      value = JSON.stringify(s);
    }
    let attr = {
      propName: propName || "",
      prefix: prefix || "",
      modifier: modifier || "",
      value: value
    };
    attrMap[propName || prefix] = attr;
  });
  return attrMap;
}

function convertControlData(layout) {
  layout = dsf.mix(true, {}, layout);
  let props = {};
  dsf.recursionComponentProps(layout, (it) => {
    props[it.designId] = it;
  });
  return {
    props: props
  };
}

function getTableSlot(ctrl) {
  let columnEl = ctrl.$el.closest("[column-id]");
  if (columnEl) {
    return columnEl.getAttribute("column-id") || "";
  }
  return "";
}

//编译scss
function compileCss(scssStr, nameSpace) {
  return new Promise((resolve, reject) => {
    if ((scssStr || "").trim()) {
      var sass = new Sass();
      var scss = [".ds-page" + (nameSpace ? '[module-name="' + nameSpace + '"]' : "") + "{", scssStr, "}"];
      var files = dsf.config.designer.scss || [];
      const p = "~_platform/assets/styles/common/";
      sass.importer(function (request, done) {
        if (request.current.startsWith(p)) {
          done({
            path: "/sass/" + request.current.replace(p, "platform/")
            // resolved:"/sass/" + request.current.replace(p, "platform/"),
          });
        } else {
          done();
        }
      });
      sass.preloadFiles(dsf.config.designer.scssDir + "scss", "", files, (dd) => {
        let scssFiles = _.map(files, (file) => `@import "${file}";`);
        scss = [...scssFiles, ...scss];
        sass.compile(scss.join("\n"), function (result) {
          if (result.status == 0) {
            let cssStr = dsf.beautify.css(result.text, {
              indent_size: "2",
              indent_char: " "
            });
            resolve(cssStr);
          } else {
            let errorMsg = "编译错误:" + result.message;
            dsf.error(errorMsg);
            reject(errorMsg);
          }
        });
      });
    } else {
      resolve("");
    }
  });
}

//创建元数据，如果是表单模式则校验元数据是否同源并提示
/**
 *
 * @param {*} page 页面实例
 * @param {*} mobile 是否是移动端
 * @param {*} designer 设计器实例
 * @param {*} metadataDifferentSources 表示保存时候是否要校验元数据是否同源
 * @returns
 */
//metadataDifferentSources表示
function createAndCheckMetaDataSource(page, mobile, designer, metadataDifferentSources) {
  metadataDifferentSources = dsf.isDef(metadataDifferentSources) ? metadataDifferentSources : designer.metadataDifferentSources;

  const _openMetaDataChangeDialog = (md, list, metadataSource, resolve, reject) => {
    openMetaDataChangeDialog(
      list,
      metadataSource,
      (hasChange) => {
        if (hasChange) {
          //如果数据发生过修改则重新创建元数据
          md = dsf.designer.createViewMetaData(page, mobile);
        }
        resolve(md);
      },
      () => {
        resolve();
      }
    );
  };
  return new Promise((resolve, reject) => {
    let md = dsf.designer.createViewMetaData(page, mobile);
    if (md.mode != "prototype" && md.pageState == "form" && metadataDifferentSources) {
      if (md.metadata && !dsf.isEmptyObject(md.metadata)) {
        let list = [];
        let metadataSource = [];
        let isExistNew = false;
        _.each(md.metadata, (m, i) => {
          let arr = i.split(".");
          let prefix = arr[0];
          let name = arr[1] ? arr[1] : "";
          /**
           * m.ref元数据有对应的组件
           * m.pinyinField元数据是一个拼音
           * m.ref.isFormControl元数据对应的组件是一个表单组件
           * m.ref.isOneToMany 元数据对应的组件并非子表组件
           * m.level 元数据对应的组件是主表字段，level为0标识主表字段，level为1表示子表字段
           */
          if (m.ref && !m.pinyinField && m.ref.isFormControl && !m.ref.isOneToMany && m.level == 0) {
            //子表在创建元数据时就强制同源，所以此处只验证主表是否同源
            let obj = {
              ctrl: m.ref,
              source: prefix
            };
            if (m.$isNew) {
              isExistNew = true;
            }
            dsf.array.ensure(metadataSource, prefix);
            list.push(obj);
          }
        });
        if (metadataSource.length > 0) {
          let message = "";
          if (isExistNew) {
            if (metadataSource.length == 1) {
              message = `发现当前页面有新增的字段，默认属于<b style='color:blue'>${metadataSource[0]}</b>元数据下,确定提交吗?`;
            } else if (metadataSource.length > 1) {
              message = `发现当前页面有多组元数据，分别是:<b style='color:blue'>${metadataSource.join("，")}</b>,确定提交吗?`;
            }
          }
          if (message) {
            (message = message + "<br/><div style='color:red;font-weight:bold'>注：提交后将创建数据表和字段，如提交了错误的元数据所产生的字段需人为处理！！！！</div>"),
            dsf.layer
              .confirm({
                message: message,
                confirmButtonText: "确定提交",
                cancelButtonText: "我要修改"
              })
              .then(() => {
                resolve(md);
              })
              .catch(() => {
                window.setTimeout(() => {
                  _openMetaDataChangeDialog(md, list, metadataSource, resolve, reject);
                }, 500);
              });
          } else {
            resolve(md);
          }
        } else {
          //当页面上未产生任何元数据时候提示选择一个
          _openMetaDataChangeDialog(md, list, metadataSource, resolve, reject);
        }
      } else {
        resolve(md);
      }
    } else {
      resolve(md);
    }
  });
}

//自动保存布局
async function autoSaveLayout(designer) {
  let page = designer.$refs.viewProxy;
  let errorMsg = "";
  let successMsg = "";
  let md = null;
  try {
    md = await createAndCheckMetaDataSource(page, designer.mobile, designer, false);
    if (md) {
      md.mode = "prototype";
      compileFormulaCode(page);
      //执行报错前事件
      if (designer.postSaveBefore && dsf.isFunction(designer.postSaveBefore)) {
        await designer.postSaveBefore({ metadata: md });
      }
      let res = await postLayoutInfo(designer, page, md);
      successMsg = "布局已经自动暂存";
      designer.$emit("saved", res);
    }
  } catch (ex) {
    dsf.error(ex);
    errorMsg = "";
  } finally {
    await designer.$nextTick();
    if (errorMsg) {
      dsf.layer.pc.message(errorMsg, false);
    } else if (successMsg) {
      dsf.layer.pc.message(successMsg);
    }
  }
}

//保存布局
async function saveLayout(designer) {
  let errorMsg = "";
  let successMsg = "";
  try {
    let result = await customPostLayout(designer, async ({ designer, page, md }) => {
      return await postLayoutInfo(designer, page, md);
    });
    successMsg = "保存成功";
    designer.$emit("saved", result);
    window?.opener?.postMessage?.(
      {
        type: "designerSaved"
        // result
      },
      "*"
    );
  } catch (ex) {
    dsf.error(ex);
    if (dsf.isString(ex)) {
      errorMsg = ex;
    } else {
      errorMsg = "保存失败";
    }
  } finally {
    await designer.$nextTick();
    if (errorMsg) {
      dsf.layer.pc.message(errorMsg, false);
    } else if (successMsg) {
      dsf.layer.pc.message(successMsg);
    }
  }
  // let page = designer.$refs.viewProxy;
  // // designer.loading = true;
  // let loading = dsf.layer.pc.loading({ text: "正在解析布局..." });
  // await designer.$nextTick();
  // return new Promise((reslove, reject) => {
  //   window.setTimeout(async () => {
  //     // designer.cancelProxy = true;
  //     let errorMsg = "";
  //     let successMsg = "";
  //     let md = null;
  //     try {
  //       await designer.$nextTick();
  //       //创建并检查元数据
  //       // console.time("创建元数据");
  //       md = await createAndCheckMetaDataSource(page, designer.mobile, designer, designer.metadataDifferentSources);
  //       if (md) {
  //         // console.timeEnd("创建元数据");
  //         //执行报错前事件
  //         if (designer.postSaveBefore && dsf.isFunction(designer.postSaveBefore)) {
  //           // console.time("保存布局前");
  //           // loading.text = "保存前处理";
  //           await designer.postSaveBefore({ metadata: md });
  //           // console.timeEnd("保存布局前");
  //         }
  //         //编译公式
  //         loading.text = "表单公式编译";
  //         await designer.$nextTick();
  //         compileFormulaCode(page);
  //         loading.text = "数据提交中...";
  //         let res = await postLayoutInfo(designer, page, md);
  //         successMsg = "保存成功";
  //         designer.$emit("saved", res);
  //       }
  //       reslove();
  //     } catch (ex) {
  //       dsf.error(ex);
  //       if (dsf.isString(ex)) {
  //         errorMsg = ex;
  //       } else {
  //         errorMsg = "保存失败";
  //       }
  //       reject(ex);
  //     } finally {
  //       // designer.loading = false;
  //       dsf.layer.pc.closeLoading(loading);
  //       // designer.cancelProxy = false;
  //       await designer.$nextTick();
  //       if (errorMsg) {
  //         dsf.layer.pc.message(errorMsg, false);
  //       } else if (successMsg) {
  //         dsf.layer.pc.message(successMsg);
  //       }
  //       designer = null;
  //       loading = null;
  //       md = null;
  //     }
  //   }, 500);
  // });
}
//自定义提交布局函数
async function customPostLayout(designer, customFn) {
  if (!customFn) {
    return;
  }
  let page = designer.$refs.viewProxy;
  // designer.loading = true;
  let loading = dsf.layer.pc.loading({ text: "正在解析布局..." });
  await designer.$nextTick();
  return new Promise((reslove, reject) => {
    window.setTimeout(async () => {
      // designer.cancelProxy = true;
      let errorMsg = "";
      let successMsg = "";
      let md = null;
      let res = null;
      try {
        await designer.$nextTick();
        //创建并检查元数据
        // console.time("创建元数据");
        md = await createAndCheckMetaDataSource(page, designer.mobile, designer, designer.metadataDifferentSources);
        if (md) {
          // console.timeEnd("创建元数据");
          //执行报错前事件
          if (designer.postSaveBefore && dsf.isFunction(designer.postSaveBefore)) {
            // console.time("保存布局前");
            // loading.text = "保存前处理";
            await designer.postSaveBefore({ metadata: md });
            // console.timeEnd("保存布局前");
          }
          //编译公式
          loading.text = "表单公式编译";
          await designer.$nextTick();
          compileFormulaCode(page);
          loading.text = "数据提交中...";
          res = await customFn({ designer, page, md });
          // let res = await postLayoutInfo(designer, page, md);
          // designer.$emit("saved", res);
          reslove(res);
        }
      } catch (ex) {
        dsf.error(ex);
        reject(ex);
      } finally {
        // designer.loading = false;
        await designer.$nextTick();
        dsf.layer.pc.closeLoading(loading);
        // designer.cancelProxy = false;
        designer = null;
        loading = null;
        res = null;
        md = null;
      }
    }, 500);
  });
}

function compileFormulaCode(page) {
  let allFormControls = {};
  dsf.recursionComponentProps(page, (it) => {
    if (it.isFormControl) {
      allFormControls[it.designId] = it;
    }
  });
  _.each(allFormControls, (it) => {
    //将公式表达式伪代码转换为真实可运行的代码
    convertFormulaCodeToRealCode(it, allFormControls);
  });
}

function convertFormulaCodeToRealCode(component, allFormControls) {
  if (component.isFormControl) {
    let f = component.formula.formula.trim();
    if (!f) {
      delete component.formula.realFormula;
      return;
    }
    let var_reg = /\{\{(.)+?\}\}/g;
    let desid_reg = /\^\^((.)+?)\^\^/g;
    let target = component.metadata.inSubTable;
    let targetInSubTable = component.metadata.inSubTable;
    console.time("-------创建语法树----");
    let astTree = dsf.ufunc.readFormulaExpress(f);
    console.timeEnd("-------创建语法树----");
    try {
      let code = dsf.ufunc.createFormulaCodeStr(astTree, (node, parentNode, isParams) => {
        if (node.type == "block") {
          let exp = node.express;
          exp = exp.replace(var_reg, (s1, s2, s3, s4) => {
            let e = s1.replace(desid_reg, (s1, s2, s3, s4) => {
              let varb = s2.split(".");
              let designId = varb[0] || "";
              let attr = varb[1] || "";
              let metadata = (allFormControls[designId] && allFormControls[designId].metadata) || null;
              if (metadata.inSubTable) {
                return "TO_VALUE(__local__['" + allFormControls[designId].metadata_fullcode + "'],'" + attr + "')";
              } else {
                return "TO_VALUE($viewData['" + allFormControls[designId].metadata_fullcode + "'],'" + attr + "')";
              }
            });
            return e.replace(/\{\{|\}\}/g, "");
          });
          node.realCode = exp;
        } else if (node.type == "function") {
          //解析函数中的参数，如果是聚合函数则且有依赖项中有子表字段则需要追加子表循环
          if (node.pol && node.args && node.args.length > 0) {
            _.each(node.args, (it) => {
              let relInSubTable = [];
              if (it.type == "block" || (it.type == "function" && !it.pol)) {
                let argExp = it.express;
                argExp.replace(desid_reg, (s1, s2, s3, s4) => {
                  let metadata = (allFormControls[s2] && allFormControls[s2].metadata) || null;
                  if (metadata && metadata.inSubTable) {
                    relInSubTable.push(metadata.inSubTable);
                  }
                });
              }
              if (relInSubTable.length > 0 && targetInSubTable != relInSubTable[0]) {
                let exp = "$loopSubTable('" + relInSubTable[0] + "',function(__local__){\r\n" + "return  " + it.realCode + ";\r\n" + "})\r\n";
                // return exp;
                it.realCode = exp;
              } else {
                it.realCode = it.realCode;
              }
            });
          }
        }
      });
      component.formula.realFormula = code;
    } catch (ex) {
      component.formula.realFormula = "";
    }
  }
}

function openMetaDataChangeDialog(list, metadataSource, yes, cancel) {
  let isSure = false;
  dsf.layer.openDialog({
    title: "元数据修正",
    content: "DesMetaDataSource",
    width: "1200px",
    height: "60vh",
    params: {
      source: list,
      dict: metadataSource
    },
    closed: function () {
      if (!isSure) {
        cancel && cancel();
      }
    },
    btns: [
      {
        text: "确定",
        handler: (res) => {
          let list = res.yes();
          if (list === false) {
            return false;
          }
          let hasChange = false;
          _.each(list, (el, i) => {
            if (el.isChange) {
              hasChange = true;
              let ctrl = el.ctrl;
              ctrl.metadata.isuser = true;
              ctrl.metadata.id = el.mdkey.replace(/_/g, ".") + "." + ctrl.metadata.code;
              ctrl.metadata.at = el.mdkey.replace(/_/g, ".");
            }
          });
          isSure = true;
          yes && yes(hasChange);
        }
      },
      {
        text: "取消",
        handler() {
          cancel && cancel();
        }
      }
    ]
  });
  return;
}

//保存模板
async function saveLayoutToTemplate(designer) {
  if (designer.tpl == 1) {
    designer.loading = true;
    //递归清空掉所有无用的元数据
    let page = designer.$refs.viewProxy;
    // designer.cancelProxy = true;
    await designer.$nextTick();
    dsf.designer.recursionLayoutTree(page, null, null, (child) => {
      if (child.metadata && child.metadata.isFromMetaData) {
        child.metadata_fullcode = "";
      }
    });
    await designer.$nextTick();
    await postTemplateLayoutInfo.call(designer, page).finally(() => {
      designer.loading = false;
      // designer.cancelProxy = false;
    });
  }
}

//获取页面提交的布局的接口参数
async function getPostLayoutParams(designer, page, md, isPreview = false, callback) {
  if (dsf.isDef(isPreview) && dsf.isFunction(isPreview)) {
    callback = isPreview;
    isPreview = false;
  }
  //创建页面使用的元数据字典
  let mdDict = null;
  if (md) {
    let dict = setMetaDataDict.call(designer, md.metadata);
    if (!dsf.isEmptyObject(dict)) {
      mdDict = dict;
    }
  }
  // designer.loading = true;
  let staticValue = "";
  if (dsf.designer.isPrototypePage(page)) {
    staticValue = dsf.designer.getStaticValue(page);
  } else {
    staticValue = {};
  }
  let ns = (designer.page.context.B || "") + "." + (designer.page.context.M || "");
  // console.time("将页面转换为json")
  let layout = dsf.designer.getLayoutInfo(page, isPreview);
  // console.timeEnd("将页面转换为json")
  let staticRenderFns = undefined,
    render = undefined;
  if (page.compileRender) {
    //预编译render函数，当页面运行时可以减少动态编译的成本
    let tplAndProps = dsf.designer.convertTemplateAndControlData(layout);
    let compileFn = Vue.compile(tplAndProps.tpl);
    _.each(compileFn.staticRenderFns || [], (fn) => {
      if (fn) {
        if (dsf.isUnDef(staticRenderFns)) {
          staticRenderFns = [];
        }
        let fnStr = fn.toString();
        fnStr = fnStr.substring(fnStr.indexOf("{") + 1, fnStr.lastIndexOf("}"));
        staticRenderFns.push(fnStr);
      }
    });
    staticRenderFns = JSON.stringify(staticRenderFns);
    let renderStr = compileFn.render.toString();
    render = renderStr.substring(renderStr.indexOf("{") + 1, renderStr.lastIndexOf("}"));
  }
  let info = {
    layout,
    render,
    staticRenderFns,
    doc: designer.pageDocument,
    css: "",
    scss: designer.extScssCode || "",
    nameSpace: ns,
    moduleName: ns + "." + (designer.page.name || ""),
    stateSetting: designer.pageStateSetting || [],
    staticValue: staticValue,
    mdDict: mdDict,
    designerNode: {
      metadataGroup: {},
      controlGroup: {},
      businessControlGroup: {},
      fromTemplateId: designer.fromTemplateId
    }
  };
  callback && callback(info);
  info.designerNode["metadataGroup"] = _.map(designer.useMetaGroup.groups, (m) => {
    return { name: m.title || m.name, id: m.id, type: m.type };
  });
  info.designerNode["businessControlGroup"] = _.map(designer.useBusinessControlGroup.groups, (b) => {
    return { name: b.title, id: b.id, type: b.type };
  });
  info.designerNode["controlGroup"] = _.map(designer.useControlsGroup.groups, (b) => {
    return { name: b.title, id: b.id, type: b.type };
  });
  if (md && postForm.indexOf(page.pageType) >= 0) {
    let metadataGroup = [];
    _.each(md.metadata, (m, key) => {
      let arr = key.split(".");
      let metaDataKey = arr[0];
      let mID = metaDataKey.replace(/_/g, ".");
      let isExist = _.find(info.designerNode["metadataGroup"], (mg) => {
        return mg.id == mID;
      });
      if (!isExist) {
        info.designerNode["metadataGroup"].push({
          name: mID + "元数据",
          id: mID,
          type: 3
        });
      }
    });
  }
  let cssStr = await dsf.designer.compileCss(designer.extScssCode, info.moduleName);
  designer.extCssCode = cssStr;
  info.css = designer.extCssCode;
  let extJs = designer.extJsCode;
  extJs = dsf.beautify.js(extJs, {
    indent_size: "2",
    indent_char: " ",
    //保持数组压缩
    keep_array_indentation: false,
    //链式方法换行
    break_chained_methods: true,
    //换行长度
    wrap_line_length: 0,
    space_after_anon_function: true
  });
  let x = "/";

  let post = {
    isMobile: designer.mobile,
    md: JSON.stringify(md, (k, v) => (k == "ref" || k.startsWith("$") ? undefined : v)),
    stateSetting: JSON.stringify(info.stateSetting || []),
    layout: [
      `<script type="text/template" id="layout">\n${controlToJson(info.layout, (k, v) => {
        return k == "$isNew" ? undefined : v;
      })}\n<${x}script>`,
      info.render ? `<script type="text/template" id="render">\n${info.render}\n<${x}script>` : "",
      info.staticRenderFns ? `<script type="text/template" id="staticRenderFns">\n${info.staticRenderFns}\n<${x}script>` : "",
      `<script type="text/template" id="css">\n${info.css}\n<${x}script>`,
      `<script type="text/template" id="scss">\n${info.scss}\n<${x}script>`,
      `<script type="text/template" id="designer">\n${JSON.stringify(info.designerNode)}\n<${x}script>`,
      `<script type="text/template" id="staticValue">\n${JSON.stringify(info.staticValue)}\n<${x}script>`,
      `<script type="text/template" id="doc">\n${info.doc ? dsf.escapeFilter(info.doc.trim()) : ""}\n<${x}script>`,
      `<script type="text/template" id="metadatedict">\n${info.mdDict ? JSON.stringify(info.mdDict) : ""}\n<${x}script>`
      // `<script type="text/template" id="onLineComponents">\n${mdDict ? JSON.stringify(this.online) : ""}\n<${x}script>`
    ].join("\n"),
    extJsCode: extJs,
    // evJsCode: "",
    templateid: designer.fromTemplateId,
    pageName: designer.page.name,
    namespace: ns,
    pageTitle: designer.page.title
    // pageDoc: designer.pageDocument
  };
  Object.defineProperty(post, "$info", {
    enumerable: false,
    get() {
      return info;
    }
  });
  return post;
}

//提交布局信息
async function postLayoutInfo(designer, page, md, api, callback) {
  try {
    // designer.loading = true;
    // console.time("生成保存参数")
    let post = await getPostLayoutParams(designer, page, md, callback);
    // console.timeEnd("生成保存参数")
    // console.log(JSON.stringify(post))
    let designerNode = post.$info.designerNode;
    api = api || designer.saveRequest || designer.$webAPI.pageBuild;
    let res = await api(post);
    let result = res.data;
    if (result.state == "20000") {
      _.forOwn(md.metadata, (it, key) => {
        delete it?.ref?.metadata?.$isNew;
        delete it?.$isNew;
      });
      let div = $("<div>" + post.layout + "</div>");
      let layoutNode = div.find("#layout");
      let layout = JSON.parse(layoutNode.get(0).innerHTML);
      let extCss = designer.extCssCode;
      let extjs = designer.extJsCode;
      let info = {
        extjs,
        md,
        extCss,
        layout
      };
      designer.saved = true;

      designer.loadMetaDataGroup(designerNode["metadataGroup"]);
      return info;
    } else {
      throw result.message;
    }
  } catch (ex) {
    throw ex;
  } finally {
    // designer.loading = false;
  }
}

//提交模板布局信息
function postTemplateLayoutInfo(page) {
  this.loading = true;
  let layout = dsf.designer.getLayoutInfo(page);
  layout = dsf.designer.controlToJson(layout);
  let css = "";
  let scss = this.extScssCode || "";
  let ns = (this.page.context.B || "") + "." + (this.page.context.M || "");
  let moduleName = ns + "." + (this.page.name || "");
  let designer = {
    metadataGroup: {},
    controlGroup: {},
    businessControlGroup: {}
  };
  designer["metadataGroup"] = _.map(this.useMetaGroup.groups, (m) => {
    return { name: m.name, id: m.id, type: m.type };
  });
  designer["businessControlGroup"] = _.map(this.useBusinessControlGroup.groups, (b) => {
    return { name: b.title, id: b.id, type: b.type };
  });
  designer["controlGroup"] = _.map(this.useControlsGroup.groups, (b) => {
    return { name: b.title, id: b.id, type: b.type };
  });
  let x = "/";
  let post = {
    // isMobile: this.mobile,
    type: page.queryString.templateType ? page.queryString.templateType : this.mobile ? 2 : 1,
    layout: [
      `<script type="text/template" id="layout">\n${layout}\n<${x}script>`,
      `<script type="text/template" id="css"><${x}script>`,
      `<script type="text/template" id="scss">\n${scss}\n<${x}script>`,
      `<script type="text/template" id="designer">\n${JSON.stringify(designer)}\n<${x}script>`,
      `<script type="text/template" id="metadatedict"><${x}script>`
      // `<script type="text/template" id="buttonsRules">${JSON.stringify(this.buttons)}<${x}script>`,
    ].join("\n"),
    desButtonRules: JSON.stringify(this.buttons),
    pageName: this.page.name,
    namespace: ns
    // pageTitle: this.page.title,
  };

  return this.$webAPI
    .pageSaveTemplate(post)
    .done((result) => {
      result.state == 20000 ? this.$message("保存成功", true) : this.$message(result.message, false);
    })
    .error((error) => {
      this.$message("保存失败", false);
    })
    .always(() => {
      this.loading = false;
    });
}

//保存到业务组件组
function saveToBusinessComponentGroup(design, controlList) {
  let _this = design; //ddd
  dsf.layer.openDialog({
    title: "保存到",
    fullscreen: false,
    content: "DesBusinessComponent",
    width: "500px",
    height: "500px",
    btns: [
      {
        text: "确定",
        handler: (res) => {
          let data = res.radioData;
          let sublist = _.map(controlList, (el, i) => {
            let metadataInfo = el.metadata;
            let metadataList = [];
            metadataInfo = dsf.type(metadataInfo) == "array" ? metadataInfo : [metadataInfo];
            _.each(metadataInfo, (m) => {
              if (m) {
                m.metadata.id = "";
                m.metadata.at = "";
                metadataList.push(m.metadata);
              }
            });
            return {
              code: el.props.caption,
              name: el.businessLabel || el.props.label,
              thumbnail: el.thumbnail,
              version: "5.0",
              terminalText: _this.mobile ? "mobile" : "pc",
              terminalValue: _this.mobile ? "1" : "0",
              modeText: "原型模式^研发模式",
              modeValue: "0^1",
              origin: _this.business + "." + _this.module + "." + _this.pageName,
              md: metadataList ? JSON.stringify(metadataList) : "",
              groupId: data._id,
              content: JSON.stringify(el.props, (key, val) => {
                //去除掉无效提交的项
                if (key === "designId") {
                  return "";
                } else {
                  return val;
                }
              })
            };
          });
          _this.loading = true;
          _this.$http
            .post("component/saveBC", { bcStrs: JSON.stringify(sublist) })
            .then(({ data }) => {
              if (data.state == "20000") {
                dsf.layer.pc.message("保存成功", true);
                // _this.loadBusinessComponetGroup([{ id: data.data["dsfa_rm.dsfa_rm_id"] }]);
                let businessGroup = (design.useBusinessControlGroup.groups || []).map((ite) => {
                  return {
                    id: ite.id,
                    title: ite.title,
                    type: ite.type
                  };
                });
                businessGroup.length && _this.loadBusinessComponetGroup(businessGroup);
              } else {
                dsf.layer.pc.message(data.message, false);
              }
            })
            .catch((ex) => {
              dsf.httpError(ex, { message: "保存出现错误" });
            })
            .finally(() => {
              _this.loading = false;
            });
        }
      },
      {
        text: "取消"
      }
    ]
  });
}

function setMetaDataDict(metadastas) {
  let dict = {};
  if (!metadastas) {
    return dict;
  }
  for (let key in metadastas) {
    let arr = key.split(".");
    let prefix = arr[0];
    let name = arr[1] ? arr[1] : "";
    if (metadastas[key].level == 1 && !name) {
      dict[key] = {
        id: key,
        name: metadastas[key].name || "",
        type: "subtable",
        fieldsLength: 0,
        valueAttributesDetail: {},
        valueAttributes: [],
        level: 1,
        order: metadastas[key].order,
        rmId: metadastas[key].rmId || ""
      };
    } else {
      let va = metadastas[key].valueAttributes;
      let validate = metadastas[key]?.validate?.rules || [];
      let valueAttributesDetail = _.keyBy(va, "code");
      let dataSource = metadastas[key]?.dataSource || null;
      dict[key] = {
        id: key,
        name: metadastas[key].name,
        //枚举选项每个选项一个字段
        disperseFields: dsf.isDef(metadastas?.[key]?.disperseFields) ? metadastas?.[key]?.disperseFields : void 0,
        //枚举选项每个选项冗余字段和对应的值
        itemFields: dsf.isDef(metadastas[key]?.itemFields) ? metadastas[key]?.itemFields : void 0,
        //枚举类元数据值字段名称
        valueField: metadastas[key]?.valueField || void 0,
        type: "field",
        level: 0,
        hidden: metadastas[key].hidden,
        // valueAttributesRemark: valueAttributesRemark,
        fieldsLength: metadastas[key].valueAttributes && metadastas[key].valueAttributes.length,
        valueAttributes: metadastas[key].valueAttributes && _.map(metadastas[key].valueAttributes, "code"),
        valueAttributesDetail: valueAttributesDetail,
        order: metadastas[key].order,
        required: metadastas[key].required,
        rmId: metadastas[key].rmId || "",
        dataSource: dataSource,
        inColumn: metadastas?.[key]?.inColumn || void 0
      };
      if (dict[prefix]) {
        dict[key].level = 1;
        dict[key].inSubTable = prefix;
      }
    }
  }
  return dict;
}

function isFormPage(page) {
  let t = "";
  if (page) {
    if (dsf.type(page) == "object") {
      t = page.pageType;
    } else {
      t = page;
    }
  }
  return postForm.indexOf(t) >= 0;
}

function isPrototypePage(page) {
  let t = "";
  if (page) {
    if (dsf.type(page) == "object") {
      t = page.mode;
    } else {
      t = page;
    }
  }
  return t === enums.viewMode.PROTOTYPE;
}

//获取组件属性的json配置
function getComponentPropries(designer, ctrlType, folder) {
  let defaultPath = `$/pd_attributes/${folder}/${ctrlType}.json`;
  if (designer.propertyJsonPath) {
    return designer.$http.get(`$/${designer.propertyJsonPath}/${folder}/${ctrlType}.json`).catch(() => {
      return designer.$http.get(defaultPath);
    });
  } else {
    return designer.$http.get(defaultPath);
  }
}

function beginEditTextConent(target) {
  target = $(target);
  if (!target.hasClass("ds-text-content")) {
    target = target.children(".ds-text-content");
  }
  if (target) {
    setTimeout(() => {
      target?.focus?.();
      target?.select?.();
    }, 200);
  }
}

function triggerDialogPropty(prop) {
  let propel = $(".designer-props").find("[rel='" + prop + "']");
  propel.find(".ds-button")?.get?.(0)?.click?.();
}

export default {
  getParentControl,
  isAllowDrop,
  controlToJson,
  broadcast,
  getStaticValue,
  getLayoutInfo,
  getDsfComponent,
  recursionLayoutTree,
  createPinyinField,
  createViewMetaData,
  checkMetadataControlValue,
  createComponentMetaData,
  getComponentByTarget,
  createComponent,
  createMobileComponent,
  convertTemplateAndControlData,
  convertControlData,
  saveLayoutValidate,
  saveToBusinessComponentGroup,
  compileCss,
  validateCaption,
  getExtPath,
  getPageDocumet,
  getLayoutPath,
  saveLayout,
  autoSaveLayout,
  customPostLayout,
  saveLayoutToTemplate,
  compileFormulaCode,
  getPostLayoutParams,
  postLayoutInfo,
  isFormPage,
  isPrototypePage,
  getComponentPropries,
  getRealComponent,
  beginEditTextConent,
  triggerDialogPropty,
  analysisLayoutInfo,
  requestAsyncComponentsByLayout,
  getComponentCodeByClient
};
